import LoginStore from '../stores/LoginStore.js'
import t from '../helpers/Languages.js'
import branchesAvailable from '@utils/branchesAvailable.js'
import {setStoredColumnVisible} from '@components/UI/table/hooks/useTableSettings.js'

// Every table that renders a branch column: the tableName it stores its settings under, the translation key of the
// column title, the column id and the tableName it stored its settings under before (see Table's legacyTableName)
const branchColumnTables = [
    ['dashboard', 'branch', 'branchName'],
    ['customers', 'branch', 'branchName'],
    ['users', 'branches', 'branchNames'],
    ['vehicles', 'branch', 'branchName'],
    ['shifts', 'branch', 'branchName'],
    ['shiftTemplates', 'branch', 'branchName'],
    ['invoices', 'branch', 'branchName'],
    ['subscriptions', 'branch', 'branchName'],
    ['RouteTemplates', 'branch', 'branchName'],
    ['orderTemplates', 'branch', 'branchName'],
    ['parcels', 'branch', 'branchName'],
    ['addressBook', 'branch', 'branchName'],
    ['packages', 'branch', 'branchName', 'undefined']
]

// The branch columns are hidden by default and a choice in the table settings wins over that, so making them show
// up means storing that choice for each table
export function showBranchColumns() {
    for (const [tableName, titleKey, id, legacyTableName] of branchColumnTables) {
        setStoredColumnVisible(tableName, {id, title: t(titleKey)}, true, legacyTableName)
    }
}

export function getAvailableBranches(reseller, user) {
    if (!branchesAvailable(reseller)) {
        return []
    }

    const branches = reseller?.settings?.branches || []
    const currentUser = user || LoginStore.state.user

    if (currentUser?.isOwner) {
        return branches
    }

    if (!currentUser?.branchIds?.length) {
        return []
    }

    return branches.filter((branch) => currentUser.branchIds.includes(branch.id))
}
